import { Modal } from "@mui/material";
import { CMWizardModal } from "./wizard-modal.styles2";

const WizardModal2 = ({
  children,
  open,
  handleClose,
  onClose,
  closeTransition,
  ...props
}) => {
  return (
    <Modal open={open} onClose={handleClose} {...props}>
      <CMWizardModal className="center-absolute">
        {children}
      </CMWizardModal>
    </Modal>
  );
};

export default WizardModal2;
